<template>
  <div class="widget-country">
    <widget-flag
      class="widget-country__flag"
      :country-code="countryCode"
    />

    <div class="widget-country__text">
      {{ title }}
    </div>
  </div>
</template>

<script lang="ts">
import WidgetFlag from '@widgets/shared/components/WidgetFlag.vue'
import { defineComponent, type PropType } from '@/composition/vue/compositionApi'
import { type TmCountryCode, TmFakeCountryCode } from '@/services/types'

export default defineComponent({
  components: {
    WidgetFlag,
  },
  props: {
    countryCode: {
      type: String as PropType<TmCountryCode>,
      default: TmFakeCountryCode,
    },
    title: {
      type: String,
    },
  },
})
</script>

<style lang="scss" scoped>
.widget-country {
  display: flex;
  width: 100%;
  align-items: center;
  color: $emphasize;

  &__flag:not(:last-child) {
    margin-right: 8px;
  }

  &__text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.2;
  }
}
</style>
